export default __webpack_public_path__ + "static/media/to-do-light.2698ca20.jpg";